import api from '../../plugins/api';

// GET /api/shop/getStockFilters — значения фильтров стока и число машин под каждым.
// Принимает те же параметры, что и getItems: выбранные фильтры сужают списки друг друга.
const getStockFilters = (params) => {
  return api.get('/api/shop/getStockFilters', params);
};

export default getStockFilters;
